import { Component, Input, OnChanges } from '@angular/core';
import * as _ from 'lodash';
import { UpgradeNavigationServiceHandler } from '../Common/Routing/upgrade-navigation-handler.service';
import { Address } from '../Common/Models/common.model';

@Component({
    selector: 'site-map-info-window',
    template: `
        @if (!siteMarkerInfoArr.length) {
          <div class="text-center" style="padding: 15px;">
            <i class="fa fa-spinner fa-pulse fa-4x"></i>
          </div>
        }
        @if (siteMarkerInfoArr.length) {
          <div>
            @if (siteMarkerInfoArr.length > 1) {
              <select class="form-select-sm" [(ngModel)]="selectedMarkerInfo">
                @for (site of siteMarkerInfoArr; track site) {
                  <option [ngValue]="site">{{site.siteName}}</option>
                }
              </select>
            }
            <h5>{{selectedMarkerInfo.companyName}}</h5>
            <h4><a class="pointer" (click)="navigateToSite()">{{selectedMarkerInfo.siteName}}</a></h4>
            <table class="site-map-info">
              <tr>
                <td>
                  <div>@for (type of getAbbrevs(selectedMarkerInfo.propertyTypeAbbrevs); track type) {
                    <span class="label label-primary property-type-{{type}}" style="margin-left: 3px;">{{type}}</span>
                  }</div>
                  <div style="margin-top: 5px;"><em>{{selectedMarkerInfo.siteClassPrimaryDesc}}</em></div>
                </td>
                <td>
                  <address-view-edit class="map-site-address" [address]="address"></address-view-edit> <br>
                </td>
              </tr>
              <tr>
                <td>
                  lat: {{selectedMarkerInfo.address.latitude}} <br>
                  lng: {{selectedMarkerInfo.address.longitude}}
                </td>
                <td>
                  SqFt: {{selectedMarkerInfo.totalSqFt | number:'1.0-0'}} <br>
                  Units: {{selectedMarkerInfo.totalUnits | number:'1.0-0'}}
                </td>
              </tr>
            </table>
          </div>
        }
        `,
    styleUrls: ['./site.map.component.scss'],
    standalone: false
})
export class SiteMapInfoWindowComponent implements OnChanges {
    constructor(private _upgradeNavigationServiceHandler: UpgradeNavigationServiceHandler) {
    }

    @Input() siteMarkerInfoArr: Core.SiteMarkerInfo[];
    selectedMarkerInfo: Core.SiteMarkerInfo;

    get address() {
        return this.selectedMarkerInfo.address as unknown as Address;
    }

    ngOnChanges() {
        if (this.siteMarkerInfoArr.length) {
            this.selectedMarkerInfo = this.siteMarkerInfoArr[0];
        }
    }

    getAbbrevs(propertyTypeAbbrevs: string): string[] {
        return _.words(propertyTypeAbbrevs);
    }

    navigateToSite(): void {
        const url = this._upgradeNavigationServiceHandler.getHrefFromState('siteRedirect', { entityId: this.selectedMarkerInfo.siteId });

        window.open(url, '_blank');
    }

}
